import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../styles/stylesConstants';
import { themeColors } from '../../styles/themeColors';

export default makeStyles((theme: Theme) => ({
  container: {
    width: stylesConstants.inputFormWidth,
  },
  selectUploadContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },

  imagePreviewContainer: {
    borderRadius: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    backgroundColor: themeColors.innerBackground,
    border: stylesConstants.defaultBorder,
    display: 'flex',
    maxWidth: stylesConstants.inputFormWidth,
    height: 249,
    overflow: 'hidden',
    position: 'relative',
  },
}));
